import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex align-center pe-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { icon: "mdi-view-dashboard" }),
          _cache[0] || (_cache[0] = _createTextVNode("   Dashboard ")),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Dashboard ")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}